__turbopack_context__.v({
  "address": "InsuranceHalfTextHalfMap-module-scss-module__BbshXq__address",
  "insuranceHalfTextHalfMap": "InsuranceHalfTextHalfMap-module-scss-module__BbshXq__insuranceHalfTextHalfMap",
  "insuranceHalfTextHalfMapSection": "InsuranceHalfTextHalfMap-module-scss-module__BbshXq__insuranceHalfTextHalfMapSection",
  "mapContainer": "InsuranceHalfTextHalfMap-module-scss-module__BbshXq__mapContainer",
  "mapSection": "InsuranceHalfTextHalfMap-module-scss-module__BbshXq__mapSection",
  "mapWrapper": "InsuranceHalfTextHalfMap-module-scss-module__BbshXq__mapWrapper",
  "textSection": "InsuranceHalfTextHalfMap-module-scss-module__BbshXq__textSection",
});
